import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { DataConnectionContentType, WorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { Workbooks } from '~src/workbook/resources/Workbooks';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const ConnectedWorkbooksInDatasourceDefinition: ExplorableItemDefinition = {
  itemType: 'connectedWorkbook',
  pluralName: Messages.connectedWorkbooks,
  singularName: Messages.connectedWorkbook,
  emptyStateMessage: Messages.connectedWorkbooksEmptyMessage,
  contentFilterKeys: DataConnectionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['connectedWorkbook']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Workbooks.all().withExtraParams(WorkbookContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list', 'thumbnail'],
};
